export const ROLES_KEY = 'https://advertiser.bankrate.com/user_roles'

export interface UserModel {
  name: string
  email: string
  picture: string
  user_id: string
  app_metadata: {
    roles: UserRole[]
  }
}

export interface TokenUserModel {
  iss: string
  sub: string
  iat: number
  exp: number
  azp: string
  aud: string
  [ROLES_KEY]: UserRole[]
  name: string
}

export enum UserRole {
  STAFF_ROLE = 'staff',
  RATES_QC_ROLE = 'rates-qc',
  RATES_ADMIN_ROLE = 'rates',
  EDITORIAL_ROLE = 'editorial'
}
